import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { BedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { useUpdateBedroomMutation } from '../../../../hooks/useUpdateBedroomMutation';

export interface EditBedroomInputs {
  floor: number;
  doorNumber: string;
  maxUsers: number;
}

const schema = yup
  .object({
    floor: yup.number().required("L'étage est requis"),
    doorNumber: yup.string().required('Le numéro de la chambre est requis'),
    maxUsers: yup.number().required('Le nombre de places est requis'),
  })
  .required();

export const useEditBedroomDrawer = (
  bedroom: BedroomsQuery['bedrooms'][0],
  onClose: () => void,
) => {
  const { updateBedroom } = useUpdateBedroomMutation(() => {
    onClose();
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<EditBedroomInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      doorNumber: bedroom.doorNumber,
      floor: bedroom.floor,
      maxUsers: bedroom.maxUsers,
    },
  });

  const onValid: SubmitHandler<EditBedroomInputs> = async (data) => {
    updateBedroom({
      bedroomId: bedroom.id,
      ...data,
    });
  };

  const onSubmit = handleSubmit(onValid);

  return {
    onSubmit,
    register,
    errors,
  };
};
